import { render, staticRenderFns } from "./ExpandableList.vue?vue&type=template&id=8dbd81ea&scoped=true"
import script from "./ExpandableList.vue?vue&type=script&lang=js"
export * from "./ExpandableList.vue?vue&type=script&lang=js"
import style0 from "./ExpandableList.vue?vue&type=style&index=0&id=8dbd81ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbd81ea",
  null
  
)

export default component.exports